// export const getWebhookMutationKey = () => [`planner_webhook`];
export const getWebhookMutationKey = (projectId: string | undefined) => [`planner_webhook`, projectId];
